var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',[_c('seletor',{attrs:{"elements":_vm.elements}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }